// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"styles_spinnerContainer__UTgjb","spinner":"styles_spinner__OS1kQ"};